
export const SING_COLORS = {
  BLUE: '#00758d',
  MAGENTA: '#8E0B56',
  BURGUNDY: '#4A041E',
  GOLD: '#dfc32f',
  DARK: '#00303c'
};

export const DEFAULT_INCLUDED_SERVICES = [
  { iconName: 'Wifi', label: 'WiFi haut débit', description: 'Connexion fibre optique stable et rapide', order: 1 },
  { iconName: 'Coffee', label: 'Espace détente', description: 'Machine à café, thé et zone de repos', order: 2 },
  { iconName: 'ShieldCheck', label: 'Accès sécurisé', description: 'Environnement surveillé et sécurisé', order: 3 },
  { iconName: 'Zap', label: 'Électricité & Climatisation', description: 'Confort thermique et prises disponibles', order: 4 },
  { iconName: 'Monitor', label: 'Écrans disponibles', description: 'Écrans de travail ou de projection', order: 5 },
  { iconName: 'Key', label: 'Casiers sécurisés', description: 'Stockage sécurisé pour vos effets personnels', order: 6 },
];

export const PROCESS_TEMPLATES = {
  IMMEDIATE: [
    { stepNumber: 1, title: 'Choisissez votre formule', subtitle: 'Demi-journée, journée ou pack', order: 1 },
    { stepNumber: 2, title: 'Remplissez le formulaire', subtitle: 'Informations et date', order: 2 },
    { stepNumber: 3, title: 'Payez en ligne', subtitle: 'Paiement sécurisé SINGPAY', order: 3 },
    { stepNumber: 4, title: 'Confirmation immédiate', subtitle: 'Reçu par email', order: 4 },
  ],
  QUOTE_REQUIRED: [
    { stepNumber: 1, title: 'Demande de devis', subtitle: 'Choisissez vos dates et options', order: 1 },
    { stepNumber: 2, title: 'Étude du dossier', subtitle: 'Réponse sous 48h maximum', order: 2 },
    { stepNumber: 3, title: 'Validation du devis', subtitle: 'Paiement de l\'acompte en ligne', order: 3 },
    { stepNumber: 4, title: 'Réservation confirmée', subtitle: 'Votre créneau est bloqué', order: 4 },
  ],
  APPLICATION_REQUIRED: [
    { stepNumber: 1, title: 'Dépôt du dossier', subtitle: 'Formulaire et documents requis', order: 1 },
    { stepNumber: 2, title: 'Comité de sélection', subtitle: 'Analyse de votre projet', order: 2 },
    { stepNumber: 3, title: 'Entretien & Visite', subtitle: 'Rencontre avec les équipes SING', order: 3 },
    { stepNumber: 4, title: 'Installation', subtitle: 'Signature du contrat & accès', order: 4 },
  ],
};

export const WORKFLOW_BADGE_MAP = {
  IMMEDIATE: { label: 'Réservation instantanée', iconName: 'Zap', color: SING_COLORS.BLUE },
  QUOTE_REQUIRED: { label: 'Sur devis', iconName: 'FileText', color: SING_COLORS.MAGENTA },
  APPLICATION_REQUIRED: { label: 'Sur dossier', iconName: 'Building2', color: SING_COLORS.DARK },
};

export const PROMO_TAGS = [
  { value: '', label: 'Aucun', color: '#9ca3af' },
  { value: 'BEST VALUE', label: 'Meilleur choix (Best Value)', color: SING_COLORS.BLUE },
  { value: 'MOST POPULAR', label: 'Le plus choisi', color: SING_COLORS.GOLD },
  { value: 'PROMO', label: 'Promotion', color: SING_COLORS.MAGENTA },
  { value: 'NEW', label: 'Nouveauté', color: SING_COLORS.BURGUNDY },
];
